import { useMemo } from 'react';

export const useIdsGenerator = (array, dep = []) => {
  return useMemo(() => {
    return array.map((i, index) => index);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [array, ...dep]);
};
